export default __webpack_public_path__ + "static/broadband-fusion-facts-aba8b0ef5bcf8cb8d8f97f94a731ed4c.pdf";